// src/utils/adminUtils.js
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Verilen kullanıcı ID'si için admin yetkisi olup olmadığını kontrol eder.
 * Yetki, Firestore'da kullanıcı dokümanında role: "admin" olarak tanımlanmalı.
 * @param {string} userId - Kontrol edilecek kullanıcı ID'si
 * @returns {Promise<boolean>} - Admin yetkisi varsa true, yoksa false
 */
export const checkIsAdmin = async (userId) => {
  try {
    if (!userId) {
      console.warn("Kullanıcı ID'si sağlanmadı.");
      return false;
    }

    const userRef = doc(db, "users", userId);
    const snapshot = await getDoc(userRef);

    if (!snapshot.exists()) {
      console.warn(`Kullanıcı bulunamadı: ${userId}`);
      return false;
    }

    const data = snapshot.data();
    const isAdmin = data.role === "admin";
    if (!isAdmin) {
      console.log(`Kullanıcı admin değil: ${userId}`);
    }
    return isAdmin;
  } catch (err) {
    console.error("Admin kontrolü sırasında hata:", err);
    throw new Error(`Admin yetkisi kontrol edilemedi: ${err.message}`);
  }
};